import { inject, Pipe, PipeTransform } from '@angular/core';

import { BlockModel } from '@empathy/survey/base';

import { SurveyEditorService } from '../services/survey-editor.service';

@Pipe({
  name: 'inBlock',
  pure: true
})
export class InBlockPipe implements PipeTransform {
  private surveyEditorService = inject(SurveyEditorService);

  transform(qId: string): BlockModel {
    return this.surveyEditorService.surveyEditor$().blocks.byGroupedQId(qId);
  }
}
